import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import "./assets/animations.scss";
import gsap from "gsap";
import Draggable from "gsap/Draggable";
import "animate.css/animate.css";

Vue.config.productionTip = false;

window.scaleRatio = 0;

Vue.mixin({
  data: function() {
    return {
      get isProd() {
        return process.env.NODE_ENV;
      }
    };
  }
});

Vue.directive("drag", {
  inserted(el, binding, vnode) {
    let _this = vnode.context;
    gsap.registerPlugin(Draggable);
    Draggable.create(el, {
      type: "x,y",
      liveSnap: {
        points: function(point) {
          var dx = point.x - el.dataset.dropX;
          var dy = point.y - el.dataset.dropY;
          if (Math.sqrt(dx * dx + dy * dy) < 100) {
            return { x: el.dataset.dropX, y: el.dataset.dropY };
          }
          return point;
        }
      },
      onDragEnd: function() {
        el.style.transform = el.style.transform.replace(/rotate\(.*\)/, "");
        if (this.endX == el.dataset.dropX && this.endY == el.dataset.dropY) {
          _this.points++;
          if (_this.points >= 4) _this.play();
        }
      }
    });
  }
});

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
